import { SET_LOCALE, SET_FALLBACK_LOCALE } from '@/store/_mutationtypes'

const state = {
  currentLocale: localStorage.getItem('estamp-locale') || 'en',
  fallbackLocale: 'en',
  availableLocales: ['en', 'fr'],
  localeNames: {
    en: 'English',
    fr: 'Français'
  }
}

const mutations = {
  [SET_LOCALE](state, locale) {
    state.currentLocale = locale
    localStorage.setItem('estamp-locale', locale)
  },
  [SET_FALLBACK_LOCALE](state, locale) {
    state.fallbackLocale = locale
  }
}

const actions = {
  async setLocale({ commit, rootState }, locale) {
    if (state.availableLocales.includes(locale)) {
      commit(SET_LOCALE, locale)
      
      // Update i18n locale
      if (rootState.$i18n) {
        rootState.$i18n.locale = locale
      }
      
      // Update DevExtreme locale
      try {
        const { updateDevExtremeLocale } = require('@/i18n/plugins/devExtreme')
        updateDevExtremeLocale(locale)
      } catch (error) {
        console.warn('Failed to update DevExtreme locale:', error.message)
      }
      
      // Update Moment.js locale
      try {
        const { updateMomentLocale } = require('@/i18n/plugins/moment')
        updateMomentLocale(locale)
      } catch (error) {
        console.warn('Failed to update Moment.js locale:', error.message)
      }
      
      return Promise.resolve(locale)
    }
    return Promise.reject(new Error(`Unsupported locale: ${locale}`))
  },
  
  initializeLocale({ dispatch }) {
    const savedLocale = localStorage.getItem('estamp-locale')
    if (savedLocale && state.availableLocales.includes(savedLocale)) {
      return dispatch('setLocale', savedLocale)
    }
    return dispatch('setLocale', 'en')
  }
}

const getters = {
  currentLocale: state => state.currentLocale,
  availableLocales: state => state.availableLocales,
  localeNames: state => state.localeNames,
  currentLocaleName: state => state.localeNames[state.currentLocale]
}

export const i18n = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}